import axios, {AxiosResponse} from 'axios'
const api = '/api/user/'
// Get all users
const getUsers = async ({params}) => {
  const response = await axios.get(`${api}list`, params)
  return response.data
}

const campusAndSystemList = async () => {
  const response = await axios.get(`${api}campus-and-system-list`)
  return response.data
}

const getSystemRoles = async (system_id: any) => {
  const response = await axios.post(`${api}get-system-roles`, system_id)
  return response.data
}

const getCampusUnits = async (campus_id: any) => {
  const response = await axios.get(`${api}get-campus-unit/${campus_id}`)
  return response.data
}

// Create new user
const createUser = async ({user}) => {
  await axios.post(`${api}store`, user)
}

// Get user by id
const getUserById = async (id: string): Promise<AxiosResponse<any>> => {
  const response = await axios.get(`${api}edit/${id}`)
  return response.data
}

// Update user
const updateUser = async ({user}) => {
  await axios.post(`${api}update`, user)
}

// Delete user
const deleteUser = async (user_id: string) => {
  await axios.post(`${api}destroy/${user_id}`)
}

// Update user password
const updateUserPassword = async ({data}) => {
  await axios.post(`${api}change-password`, data)
}

const startImpersonate = async ({data}) => {
  const response = await axios.post(`${api}start-impersonate`, data)
  return response.data
}

const stopImpersonate = async ({data}) => {
  const response = await axios.post(`${api}stop-impersonate`, data)
  return response.data
}

const setUserLanguage = async (lang: string) => {
  const response = await axios.get(`/api/user/set-lang/${lang}`)
  return response.data
}

const getStaffUsers = async ({params}) => {
  const response = await axios.get(`${api}staff-users`, params)
  return response.data
}

const getLecturerUsers = async ({params}) => {
  const response = await axios.get(`${api}lecturer-users`, params)
  return response.data
}

const getStudentUsers = async ({params}) => {
  const response = await axios.get(`${api}student-users`, params)
  return response.data
}

const staffStudentUserChangePassword = async ({data}) => {
  await axios.post(`${api}staff-student-user-change-password`, data)
}

const staffStudentUserDelete = async ({data}) => {
  await axios.post(`${api}staff-student-user-delete`, data)
}

const getSchoolStaffUsers = async ({params}) => {
  const response = await axios.get(`${api}school-staff-users`, params)
  return response.data
}

const getSchoolLecturerUsers = async ({params}) => {
  const response = await axios.get(`${api}school-lecturer-users`, params)
  return response.data
}

const getSchoolStudentUsers = async ({params}) => {
  const response = await axios.get(`${api}school-student-users`, params)
  return response.data
}

const schoolStaffStudentUserChangePassword = async ({data}) => {
  await axios.post(`${api}school-staff-student-user-change-password`, data)
}

const schoolStaffStudentUserDelete = async ({data}) => {
  await axios.post(`${api}school-staff-student-user-delete`, data)
}

const toggleUserStatus = async ({data}) => {
  await axios.post(`${api}toggle-status`, data)
}

const userService = {
  setUserLanguage,
  getCampusUnits,
  getUsers,
  startImpersonate,
  stopImpersonate,
  campusAndSystemList,
  getSystemRoles,
  createUser,
  getUserById,
  updateUser,
  deleteUser,
  updateUserPassword,
  getStaffUsers,
  getLecturerUsers,
  getStudentUsers,
  staffStudentUserChangePassword,
  staffStudentUserDelete,
  getSchoolStaffUsers,
  getSchoolLecturerUsers,
  getSchoolStudentUsers,
  schoolStaffStudentUserChangePassword,
  schoolStaffStudentUserDelete,
  toggleUserStatus,
}

export default userService
